<template>
  <div :class="['feedback-item', `feedback-item-${feedback.type}`]">
    <b-row align-v="center">
      <b-col cols="auto">
        <avatar :src="giverPhoto" size="2.5rem" />
      </b-col>
      <b-col>
        <b-row>
          <b-col cols="12" md>
            <span class="font-weight-bold">{{userName}}</span>
            <span v-if="hasCompanyName" class="font-italic color-gray"> {{feedback.giver.company}}</span>
          </b-col>
          <b-col cols="6" md="2"><span class="feedback-type">{{type}}</span></b-col>
          <b-col cols="6" md="2"><span class="feedback-date">{{date}}</span></b-col>
        </b-row>
        <div class="feedback-content">
          {{feedback.content}}
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import moment from 'moment'
import Avatar from '@/components/common/Avatar'
import { userName } from '@/helpers/helpers'
import { FEEDBACK_TYPE } from '@/helpers/types'

export default {
  name: 'FeedbackItem',

  props: {
    feedback: {
      type: Object,
      required: true
    }
  },

  computed: {
    date() {
      return moment(this.feedback.createdAt).fromNow()
    },

    giverPhoto() {
      return this.feedback.giver ? this.feedback.giver.photo : null
    },

    userName() {
      return this.feedback.giver ? userName(this.feedback.giver) : 'Anonymous'
    },

    hasCompanyName() {
      return this.feedback.type === FEEDBACK_TYPE.EXTERNAL &&
        this.feedback.giver && this.feedback.giver.company
    },

    type() {
      switch (this.feedback.type) {
        case FEEDBACK_TYPE.MANAGER: return 'Manager'
        case FEEDBACK_TYPE.TEAM: return 'Team'
        case FEEDBACK_TYPE.PEER: return 'Peer'
        case FEEDBACK_TYPE.EXTERNAL: return 'External'
        default: return ''
      }
    }
  },

  components: {
    Avatar
  }
}
</script>
